import React from 'react';

import { Box } from '../Box';
import { Card } from '../Card';
import { HStack } from '../HStack';
import { Icon } from '../Icon';
import { Label, Text } from '../Typography';
import { VStack } from '../VStack';
import { TaskCardProps } from './interface';

export const TaskCard = ({ title, body, iconProps, onClick }: TaskCardProps) => {
  const hasIcon = !!iconProps;

  const renderBody = () => {
    if (typeof body === 'string') {
      return <Text size="m">{body}</Text>;
    } else {
      return body;
    }
  };

  return (
    <Card elevation={1} onClick={onClick}>
      <HStack flex={1} gap={1}>
        {hasIcon && <Icon {...iconProps} boxSize="40px" iconSize="20px" />}

        <VStack pl={hasIcon ? 1 : 0} gap={0.5} flex={1}>
          <Label size="m">{title}</Label>
          {renderBody()}
        </VStack>

        <Box alignSelf="center">
          <Icon name="chevron-right" boxSize="24px" iconSize="16px" />
        </Box>
      </HStack>
    </Card>
  );
};
